import About from "./components/About";
import Contact from "./components/Contact";
import HLAPresidents from "./components/HLAPresidents";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Navbar2 from "./components/Navbar2";
import OfficeBearer from "./components/OfficeBearer";
import Skills from "./components/Skills";
import Download from "./components/Download";
import Footer from "./components/Footer";
import NoticeSection from "./components/notices/NoticeSection";


function App() {
  return (
    <div>
      <Navbar />
      <hr name='home'></hr>
      <Home />
      <About />
      <NoticeSection/>
      <OfficeBearer/>
      <HLAPresidents/>
      {/* <Skills /> */}
      <Download />
      <Contact />
      <Footer/>
    </div>
  );
}

export default App;
